export enum ProductTypeEnum {
    qira = 'QIRA',
    shitje = 'SHITJE',
}
